import { MutationTree } from 'vuex'
import StockState from '../../types/StockState'
import * as types from './mutation-types'

const mutations: MutationTree<StockState> = {
  [types.SET_STOCK_CACHE] (state, cache) {
    state.cache = cache
  },
  [types.SET_STOCK_CACHE_PRODUCT] (state, { productId, productInfo }) {
    state.cache = Object.assign({}, state.cache, {
      [productId]: productInfo
    })
  },
  [types.SET_IS_STOCK_INFO_LOADING] (state, value) {
    state.isStockInfoLoading = value
  },
  [types.SET_MAX_QUANTITY] (state, value) {
    state.maxQuantity = value
  }
}

export default mutations
